<template>
    <div id="opening">
        <div class="section opening-section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 offset-lg-6" data-aos="fade-up" data-aos-duration="1200">
                        <div class="box-icon"><span class="ti-mobile gradient-fill ti-3x"></span></div>
                        <h2 class="section-title">{{ $t('פיתוח בסטנדרט של סטארטאפ') }}</h2>
                        <p class="mb-4 section-text">
                            {{ $t('מתוך אמונה שהטכנולוגיה שייכת לכולם, החלטנו להיות הראשונים שבאמת מנגישים את הטכנולוגיות החדשניות ביותר שעד כה היו שמורות לסטארטאפים וחברות ענק - לכולם!') }}
                            <br>
                           {{ $t(' ככל שיותר מיזמים יצליחו, נקדם את האנושות למקום טוב יותר.') }}
                        </p>
                        <p class="mb-4 section-text">
                            <strong>{{ $t('פיתחנו סיסטם טכנולוגי יחודי שמאיץ תהליכי פיתוח של אפליקציות ואתרים מותאימים אישית מ-0 ועוזר לנו להגיש לכם את מערכת החלומות שלכם - במהירות שיא.') }}</strong>
                        </p>
                        <p class="mb-4 section-text">
                            {{ $t('אנחנו מאמינים באיכות גבוהה ללא פשרות בכל דבר שאנחנו עושים.') }}
                            <br>
                            {{ $t('חברת הטכנולוגיה שלך, שחושבת סטארטאפ בדיוק כמוך.') }}
                        </p>
                        <button v-scroll-to="'#services'" class="btn to-contact-button">{{ $t('מה אנחנו מציעים') }}</button>
                    </div>
                </div>
                <div class="perspective-phone" data-aos="fade-up" data-aos-duration="1200">
                    <img src="/img/opening/pamoja.png" alt="perspective phone" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'opening',
    }
</script>

<style lang="css" scoped>
    .section-title {
        font-size: 45px;
        font-weight: 300;
        letter-spacing: -1px;
        margin-bottom: 1rem;
        color: #fff;
    }
    .opening-section {
        background-image: linear-gradient(to bottom, #00c092, #00a4b9);
    }
    .perspective-phone {
        text-align: left;
        direction: ltr;
    }
    button.to-contact-button {
        height: 48px;
        min-width: 185px;
        color: #ffffff;
        font-weight: 500;
        border-radius: 22px 25px 22px 22px;
        cursor: pointer;
        display: block;
        margin: auto;
        background: linear-gradient(144deg, #7719b4 10%, #bf35d0 65%);
        border: none;
    }
    p.section-text {
        font-size: 18px;
        color: #fff;
        line-height: 1.5;
    }
    @media(max-width:767px) {
        .perspective-phone {
            padding-top: 50px;
            padding-bottom: 50px;
        }
    }
</style>
